<template>
  <div v-if="embedUrl" class="video-embed">
    <!-- "allow" takes precedence over "allowfullscreen", so fullscreen has to be listed in it -->
    <iframe
      :src="embedUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
  import { parseVideoLink } from "@/utils/videos";

  // Embedded player for a YouTube, Vimeo or Dailymotion link (replaces v-video-embed).
  export default {
    name: "VideoEmbed",
    props: {
      src: {
        type: String,
        default: "",
      },
    },
    computed: {
      embedUrl() {
        const video = parseVideoLink(this.src);
        return video ? video.embedUrl : null;
      },
    },
  };
</script>

<style scoped>
  .video-embed {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
  }

  .video-embed iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
</style>
